import { render, staticRenderFns } from "./NotificationSuccess.vue?vue&type=template&id=32456d0d&"
import script from "./NotificationSuccess.vue?vue&type=script&lang=js&"
export * from "./NotificationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports